import * as React from "react";
const SvgIcCollect = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 0H10C4.47715 0 0 4.47715 0 10V20L10 10L20 0Z", fill: "#B2F5D4" }));
export default SvgIcCollect;
